const additionalSounds = [
    {
        src: "sounds/game4_1.mp3",
        id: "click",
    },
];
export default additionalSounds;
